<template>
  <div>
    <header-bar/>
    <page-with-navigation>
        <user-navigation/>
    </page-with-navigation>
  </div>
</template>

<script>
  import PageWithNavigation from './PageWithNavigation.vue'
  import UserNavigation from './UserNavigation.vue'
  import HeaderBar from './HeaderBar.vue'
  export default {
    components: { UserNavigation, PageWithNavigation, HeaderBar }
  }
</script>



// WEBPACK FOOTER //
// src/layout/UserLayout.vue